var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "googleMapsContainer",
      staticClass: "maps-component position-relative",
      class: _vm.aspectClass
    },
    [_vm.scriptBlocked ? _c("div", [_vm._t("default")], 2) : _vm._e()]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }